import { render, staticRenderFns } from "./Dead.vue?vue&type=template&id=6b7680c8"
import script from "./Dead.vue?vue&type=script&lang=js"
export * from "./Dead.vue?vue&type=script&lang=js"
import style0 from "./Dead.vue?vue&type=style&index=0&id=6b7680c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports